import store from '@/state/store'
const fields = [
  {
    key: 'outTime',
    label: 'report.fields.outDate',
    header: 'outTime',
    filter: false,
    width: 20,
    disabled: true,
  },
  {
    key: 'inTime',
    label: 'report.fields.inDate',
    header: 'inTime',
    filter: false,
    width: 20,
    disabled: true,
  },
  {
    key: 'vehicle',
    label: 'report.fields.licensePlate',
    header: 'licensePlate',
    filter: true,
    width: 20,
  },
  {
    key: 'vehicleType',
    label: 'report.fields.vehicleType',
    header: 'vehicleType',
    filter: false,
    width: 30,
  },
  {
    key: 'driver',
    label: 'report.fields.driver',
    header: 'driver',
    filter: false,
    width: 20,
  },
  {
    key: 'geofence',
    label: 'report.report.geofence',
    header: 'geofence',
    filter: true,
    width: 10,
  },
  {
    key: 'duration',
    label: 'report.fields.duration',
    header: 'duration',
    filter: false,
    width: 10,
  },
]
if (store.getters['identity/hasAccess'](['report_imei_column:read'])) {
  fields.splice(3, 0, {
    key: 'imei',
    label: 'report.fields.imei',
    header: 'imei',
    filter: true,
    width: 20,
  })
}
export default fields
